




import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
  components: {
  }
})
export default class LogViewer extends Mixins() {
  @Prop()
  source: string;
}
